import React, { HTMLAttributes } from "react";
import classNames from "classnames";
import Dialog from "component/atoms/ModalDialog";
import HorizontalSpliiter from "component/atoms/horizontalSplitter";
import Table from "component/atoms/Table";
import "./AboutSoftwareDialog.styl";

const dialogStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",

    /// 아래 스타일은 stylus로 커스텀 되게 수정하자
    backgroundcolor: "#3c3c3c",
  },
};

/**
 * @description MessageBox UI Component Properties
 *
 * @interface IMessageBoxProps
 * @extends {HTMLAttributes<HTMLDivElement>}
 */
function AboutSoftwareDialog(props, state) {
  const {
    userID,
    item,
    model,
    version,
    companyAddress,
    manufacturingPermitNumber,
    serialNumber,
    UDI,
    website,
    show,
    onRequestClose,
  } = props;

  return (
    <Dialog.ModalPortal
      //isOpen={state.show}
      isOpen={show}
      className={classNames(
        "about-software-dialog__wrapper",
        "noselect",
        "nodrag"
      )}
      backgroundClassName={"message-box-background"}
      style={dialogStyles}
      onRequestClose={onRequestClose}
    >
      <Dialog.DialogLayout.DialogHeader
        inlist=""
        dialogPrefix="about-software-dialog__"
        onRequestClose={() => {}}
      >
        <Dialog.DialogLayout.DialogTitle
          inlist=""
          dialogPrefix="about-software-dialog__"
          className="h4 text-center" // Text-center:Bootstrap
        >
          <div className="clearfix">
            <a
              href="http://iaidimage.com/"
              target="#"
              className="brand pull-left nodrag noselect"
            >
              <div className="main-logo">
                {/* <img src={logoImage} alt={logoAlt} draggable={false} /> */}
                <div className="brand-img--simple" />
              </div>
            </a>
          </div>
        </Dialog.DialogLayout.DialogTitle>
      </Dialog.DialogLayout.DialogHeader>
      <HorizontalSpliiter />
      <Dialog.DialogLayout.DialogBody
        inlist=""
        // dialogPrefix={this.dialogPrefix}
        dialogPrefix="about-software-dialog__"
      >
        <div className="about-software-dialog__article">
          <div className="about-software-dialog__caption">User Information</div>
          <Table>
            <tbody>
              <tr>
                <td>ID</td>
                <td>{userID}</td>
              </tr>
            </tbody>
          </Table>
        </div>

        <div className="about-software-dialog__article">
          <div className="about-software-dialog__caption">SW Information</div>
          <Table striped bordered hover>
            <tbody>
              <tr>
                <td>품목</td>
                <td>{item}</td>
              </tr>
              <tr>
                <td>모델명</td>
                <td>{model}</td>
              </tr>
              <tr>
                <td>SW ver.</td>
                <td>{version}</td>
              </tr>
              <tr>
                <td>주소</td>
                <td>{companyAddress}</td>
              </tr>
              <tr>
                <td>제조허가번호</td>
                <td>{manufacturingPermitNumber}</td>
              </tr>
              <tr>
                <td>시리얼번호</td>
                <td>{serialNumber}</td>
              </tr>
              <tr>
                <td>UDI</td>
                <td>
                  {UDI &&
                    UDI.split("\n").map((line, index) => {
                      return (
                        <span key={index}>
                          {line}
                          <br />
                        </span>
                      );
                    })}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Dialog.DialogLayout.DialogBody>
      <Dialog.DialogLayout.DialogFooter
        inlist=""
        // dialogPrefix={this.dialogPrefix}
        dialogPrefix="about-software-dialog__"
        className="text-center"
      >
        <div className="about-software-dialog__contact">
          <span>
            {/* <span>Contact - </span> */}
            {"Contact - "}
            <a className="email" href="mailto:contact@lunit.io">
              {website}
            </a>
          </span>
          <br />
          <span>{"Powered by iAID Inc. 2020"}</span>
        </div>
      </Dialog.DialogLayout.DialogFooter>
    </Dialog.ModalPortal>
  );
}

export default AboutSoftwareDialog;
